import React from 'react';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import i18n from '../locales/i18n';
import { I18nextProvider } from 'react-i18next';
import Loadable from 'react-loadable';
import { Provider } from 'react-redux';
import store, { persistor } from '../store';
import { createRoot } from 'react-dom/client';

const Main = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <I18nextProvider i18n={i18n}>
          <App />
        </I18nextProvider>
      </BrowserRouter>
    </Provider>
  );
};

delete window.__PRELOADED_STATE__;

persistor.subscribe(() => {
  const root = createRoot(document.getElementById('app'));
  /* Hydrate React components when persistor has synced with redux store */
  const { bootstrapped } = persistor.getState();
  if (bootstrapped) {
    Loadable.preloadReady().then(() => {
      root.render(<Main />);
    });
  }
});
